import React from 'react';
export function ProblemSection() {
  return <section className="py-6 text-gray-800" data-id="element-157">
      <h2 className="text-2xl font-bold mb-6 text-center bg-yellow-100 py-3 border-t border-b border-yellow-300" data-id="element-158">
        The Real Problem Doctors Don't Want You to Know
      </h2>
      <p className="mb-6 leading-relaxed" data-id="element-159">
        Linda's story isn't unique. If you're reading this, you probably
        recognize yourself in her struggle.
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-160">
        But here's what Linda discovered that changed everything: Her knee pain
        wasn't from 'just getting older.'
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-161">
        Despite what her doctor told her ("it's normal at your age"), Linda's
        pain had a specific, fixable cause.
      </p>
      <p className="mb-6 leading-relaxed italic border-l-4 border-gray-300 pl-4" data-id="element-162">
        "Take these pills and learn to live with it," her orthopedist had said,
        scribbling a prescription for pain medication.
      </p>
      <p className="mb-4 leading-relaxed" data-id="element-163">Sound familiar?</p>
      <p className="mb-4 leading-relaxed" data-id="element-164">
        Linda had heard this same dismissive response from three different
        doctors. Each one offered the same "solutions":
      </p>
      <ul className="list-disc pl-8 mb-6 space-y-2" data-id="element-165">
        <li data-id="element-166">Stronger pain medications (with worse side effects)</li>
        <li data-id="element-167">Expensive injections that wore off in weeks</li>
        <li data-id="element-168">Joint replacement surgery as the "final option"</li>
        <li data-id="element-169">Physical therapy that was too painful to complete</li>
      </ul>
      <p className="mb-6 leading-relaxed" data-id="element-170">
        But Linda began to realize something disturbing. These "solutions"
        weren't actually solving anything.
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-171">
        The pills masked her pain for a few hours, then it returned worse than
        before. The side effects – stomach problems, brain fog, potential
        addiction – were almost worse than the knee pain itself.
      </p>
      <div className="bg-gray-100 p-6 rounded-lg mb-6" data-id="element-172">
        <p className="italic mb-4" data-id="element-173">
          "I was spending $200 a month on medications that made me feel like a
          zombie," Linda recalls. "And my knees still hurt."
        </p>
        <p className="mb-4" data-id="element-174">
          Linda calculated that her knee pain was costing her:
        </p>
        <ul className="list-disc pl-8 mb-4 space-y-2" data-id="element-175">
          <li data-id="element-176">$2,400 per year in medications</li>
          <li data-id="element-177">$180 per physical therapy session (with minimal results)</li>
          <li data-id="element-178">Thousands in potential surgery costs</li>
          <li className="font-bold" data-id="element-179">But worst of all... her quality of life</li>
        </ul>
      </div>
      <p className="mb-4 leading-relaxed" data-id="element-180">She was missing:</p>
      <ul className="list-disc pl-8 mb-6 space-y-2" data-id="element-181">
        <li data-id="element-182">Precious moments with grandchildren</li>
        <li data-id="element-183">Travel opportunities with her husband</li>
        <li data-id="element-184">Simple pleasures like gardening and walking</li>
        <li data-id="element-185">Her sense of independence and vitality</li>
      </ul>
      <p className="mb-6 leading-relaxed" data-id="element-186">
        The breaking point came when Emma asked, "Grandma, why don't you play
        with me anymore?"
      </p>
      <p className="mb-6 leading-relaxed font-medium" data-id="element-187">
        Linda realized her knee pain wasn't just affecting her body – it was
        stealing her identity as the fun, active grandmother she wanted to be.
      </p>
      <p className="mb-6 leading-relaxed italic" data-id="element-188">
        "I refused to accept that this was my new normal," Linda says. "There
        had to be a better way."
      </p>
    </section>;
}